export default __webpack_public_path__ + "static/years_bubble_large-16e3304ecd8acac4e31b1bddd1d0224f.png";